export interface BreakpointsMaterial {
  '(max-width: 480px)': string;
  '(max-width: 768px)': string;
  '(max-width: 1024px)': string;
  '(max-width: 1280px)': string;
  '(max-width: 1684px)': string;
  '(max-width: 2024px)': string;
  '(min-width: 2024px)': string;
}
